const SETUP_STATUS_MAP = {
  INIT: 'init',
  IN_PROGRESS: 'inprogress',
  COMPLETED: 'completed',
  FAILURE: 'failure'
};

const SYNC_STATUS_MAP = {
  IN_PROGRESS: 'inprogress',
  SUCCESS: 'success',
  FAILURE: 'failure',
  ERROR: 'error'
};

const META_STAGES_MAP = {
  CONNECT: 'connect',
  CALENDAR_DATA_MAPPING: 'calendarDataMapping'
};

const AVAILABLE_CALENDARS = [
  {
    id: 'outlook',
    label: 'Outlook',
    name: 'Outlook',
    integrationId: '1007',
    link: 'integration/oauth2/init?integrationId=1007',
    reAuthenticateLink:
      'integration/oauth2/init?integrationId=1007&reinit=true',
    SVGIcon: 'Outlook'
  },
  {
    id: 'google',
    label: 'Google',
    name: 'Google',
    integrationId: '1011',
    link: 'integration/oauth2/init?integrationId=1011',
    reAuthenticateLink:
      'integration/oauth2/init?integrationId=1011&reinit=true',
    SVGIcon: 'GoogleCalendar'
  }
];

const ERROR_CODE_MAP = {
  70001: {
    title: 'app.scheduling.errorcode.70001.title',
    message: 'app.scheduling.errorcode.70001.message'
  }
};

const getErrorCodeContent = (errorCode) => {
  const hideButtonOnErrorCode = ['70002'];

  if (errorCode) {
    const hideButton = hideButtonOnErrorCode.includes(errorCode);

    return {
      title: `app.scheduling.errorcode.${errorCode}.title`,
      message: `app.scheduling.errorcode.${errorCode}.message`,
      hideButton: hideButton
    };
  }
};

const CALENDAR_VIEWS = {
  MONTH: 'month',
  WEEK: 'week',
  WORK_WEEK: 'work_week',
  DAY: 'day',
  AGENDA: 'agenda'
};

const CALENDAR_INTEGRATION_ID = {
  OUTLOOK: '1007',
  GOOGLE: '1011'
};
export {
  SETUP_STATUS_MAP,
  SYNC_STATUS_MAP,
  META_STAGES_MAP,
  AVAILABLE_CALENDARS,
  CALENDAR_VIEWS,
  CALENDAR_INTEGRATION_ID,
  ERROR_CODE_MAP,
  getErrorCodeContent
};
